import { Hauler } from './Hauler'
import { JobStatus } from './enums/JobStatus'
import { AdditionalItem } from './AdditionalItem'
import { AttachmentParams } from './AttachmentParams'
import { AddressInfo } from './AddressInfo'
import { Slots } from './SetAvailability'

export class Job {
    id: string
    clientId: string
    jobCategoryId: string
    jobItems?: JobItems[]
    hauler?: Hauler
    haulerId?: string
    msaId: string
    address: AddressInfo
    apartmentNumber?: string
    distance?: number
    coordinates: string
    status: JobStatus
    amount: number
    clientStatus?: string
    haulerStatus?: string
    note?: string
    name?: string
    areItemsOutside?: boolean
    areItemsInside?: boolean
    isElevatorNeeded?: boolean
    areStairsNeeded?: boolean
    cancelReason?: string
    futureDateFrom: number
    futureDateTo: number
    createDate: number
    modifyDate?: number
    attachments?: AttachmentParams[]
    locationType?: any
    jobSubCategories?: any
    haulerFee?: number
    timeKeeping: number
    additionalItem?: AdditionalItem
    idHumanReadable?: string
    zip?: string
    timeStopBidding: number
    cancellationFeeFromClient?: number
    cancellationFeeFromHauler?: number
    jobCategory?: JobCategory
    timeSlots: Slots[]
    originatedFrom: string
    rated: JobRated
}
export interface JobRated {
    byClient: boolean
    byHauler: boolean
}
export class JobItems {
    subCategoryId: string
    count: number
}

export interface SubCategory {
    name: string
    price: number
}

export interface JobCategory {
    countable: boolean
    msaId: string
    status: string
    name: string
    id: string
    subcategories?: SubCategory[]
}



// WEBPACK FOOTER //
// ./src/types/Job.ts